export default "__VITE_ASSET__98255db5__"